import i18n from '../i18n'

export const colors = {
    MN: '#CAD3F1',
    KT: '#B4E2F2',
    LV: '#B3EBE9'
};
export const issues = [
    {
        id: 'intro',
        text: i18n.t('boards:tooltips.intro')
    },
    {
        id: 'trial',
        text: i18n.t('global:freeTrialTooltip')
    },
    {
        id: 'alldone',
        text: i18n.t('boards:tooltips.alldone')
    },
    {
        id: 'allprogress',
        text: i18n.t('boards:tooltips.allprogress')
    },
    {
        id: 'allnew',
        text: i18n.t('boards:tooltips.allnew')
    }
];
export const tasks = [
    {
        name: i18n.t('boards:tasks.1.name'),
        assignees: [i18n.t('boards:tasks.1.assignees.1'), i18n.t('boards:tasks.1.assignees.2')],
        column: 1,
        id: 1,
        marked: true,
        description: {
            1: i18n.t('boards:tasks.1.description.1'),
            2: i18n.t('boards:tasks.1.description.2'),
            3: i18n.t('boards:tasks.1.description.3')
        },
        order: 1
    },
    {
        name: i18n.t('boards:tasks.2.name'),
        assignees: [i18n.t('boards:tasks.2.assignees.1'), i18n.t('boards:tasks.2.assignees.2'), i18n.t('boards:tasks.2.assignees.3')],
        image: 'https://cdn.wrike.com/image/__cdnu/photo_boards_interactive_image_2%402x.jpg',
        column: 1,
        id: 2,
        order: 2,
        marked: false,
        description: {
            1: i18n.t('boards:tasks.2.description.1'),
            2: i18n.t('boards:tasks.2.description.2'),
            3: i18n.t('boards:tasks.2.description.3')
        }
    },
    {
        name: i18n.t('boards:tasks.3.name'),
        assignees: [i18n.t('boards:tasks.3.assignees.1'), i18n.t('boards:tasks.3.assignees.2'), i18n.t('boards:tasks.3.assignees.3')],
        column: 1,
        id: 3,
        image: 'https://cdn.wrike.com/image/__cdnu/photo_boards_interactive_image_1%402x.jpg',
        order: 3,
        marked: false,
        description: {
            1: i18n.t('boards:tasks.3.description.1'),
            2: i18n.t('boards:tasks.3.description.2'),
            3: i18n.t('boards:tasks.3.description.3')
        }
    },
    {
        name: i18n.t('boards:tasks.4.name'),
        assignees: [i18n.t('boards:tasks.4.assignees.1'), i18n.t('boards:tasks.4.assignees.2')],
        image: 'https://cdn.wrike.com/image/__cdnu/photo_boards_interactive_image_3%402x.jpg',
        column: 2,
        id: 4,
        order: 4,
        marked: false,
        description: {
            1: i18n.t('boards:tasks.4.description.1'),
            2: i18n.t('boards:tasks.4.description.2'),
            3: i18n.t('boards:tasks.4.description.3')
        }
    },
    {
        name: i18n.t('boards:tasks.5.name'),
        assignees: [i18n.t('boards:tasks.5.assignees.1'), i18n.t('boards:tasks.5.assignees.2')],
        column: 1,
        id: 5,
        order: 5,
        marked: false,
        description: {
            1: i18n.t('boards:tasks.5.description.1'),
            2: i18n.t('boards:tasks.5.description.2'),
            3: i18n.t('boards:tasks.5.description.3')
        }
    },
    // {
    //     name: 'Finalize Q3 OKRs for team',
    //     assignees: ['EK', 'MN'],
    //     column: 1,
    //     id: 6,
    //     order: 6,
    //     description: {
    //         1: `Stop complaining. You'll love this!`,
    //         2: `Just do the work.`,
    //         3: `You completed me!`
    //     }
    // },
    // {
    //     name: 'Hire new copy writer ASAP',
    //     assignees: ['EK', 'MN'],
    //     column: 2,
    //     id: 7,
    //     order: 7,
    //     description: {
    //         1: 'Fresh from the grill. Come get me!',
    //         2: `Set the timer and go.`,
    //         3: `You're a smashing success!`
    //     }
    // }
];

export const columns = [
    {
        name: i18n.t('boards:columns.new'),
        color: '#58c5fe',
        marked: false,
        id: 1
    },
    {
        name: i18n.t('boards:columns.inProgress'),
        color: '#74d7da',
        marked: false,
        id: 2
    },
    {
        name: i18n.t('boards:columns.completed'),
        color: '#9bca5c',
        marked: true,
        id: 3
    }
];
